import { render } from "./ProductGroups.vue?vue&type=template&id=2192b6a4&scoped=true"
import script from "./ProductGroups.vue?vue&type=script&lang=js"
export * from "./ProductGroups.vue?vue&type=script&lang=js"

import "./ProductGroups.vue?vue&type=style&index=0&id=2192b6a4&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2192b6a4"]])

export default __exports__